import { survicateConfig } from "../config/config";
import { ProviderTypeId } from "../enums/survicate.enum";
import { helpers } from "../helpers/helpers";
import { SurvicateConfig, Task } from "../interfaces/survicate.interface";
import { getFromStorage, getPaymentOrders, setToStorage } from "../utilities/utilities";

export class SurvicateService {
    private static instance: SurvicateService;
    private paymentOrders: any[];
    private survicateWindowString: string;
    private sessionStorageTasksKey: string = 'tasks';
    private paymentOrdersPeriodDays: number;
    private taskEnabledMap: Map<string, number> = new Map<string, number>();

    private constructor(config: SurvicateConfig) {
        const { survicateWindowString, paymentOrdersPeriodDays, tasks } = config;       
        this.survicateWindowString = survicateWindowString;
        this.paymentOrdersPeriodDays = paymentOrdersPeriodDays;
    }

    public isSurvicateEnabled(): boolean {
        return helpers.isSurvicateFeatureEnabled();
    }

    public getUserId(): string {
        return helpers.getUserId();
    }

    public getPaymentOrders(paymentMethodTypeId: number): Promise<any[]> {
        return new Promise((resolve, reject) => {
            if (!this.paymentOrders) {
                const now = new Date();
                const dateToISOString = now.toISOString();
        
                const dateFrom = new Date(now);
                dateFrom.setDate(now.getDate() - this.paymentOrdersPeriodDays);
                const dateFromISOString = dateFrom.toISOString();

                const providerTypeId = ProviderTypeId.PaymentTransactions; //2 - only Payment transactions
        
                getPaymentOrders(this.getUserId(), dateFromISOString, dateToISOString, paymentMethodTypeId, providerTypeId).then((result: any) => {
                    const paymentOrders = result['paymentOrders'];
                    this.paymentOrders = Array.isArray(paymentOrders) ? paymentOrders : Object.values(paymentOrders || {});
                    console.log('result:', this.paymentOrders);
                    resolve(this.paymentOrders);
                });
            } else {
                resolve(this.paymentOrders);
            }         
        });
    }

    public getTaskEnabledMap(): Map<string, number> {
        const tasks = getFromStorage(`${this.survicateWindowString}_${this.sessionStorageTasksKey}`);
        this.taskEnabledMap = new Map<string, number>(tasks);
        return this.taskEnabledMap; 
    }

    public setTaskEnabledMap(taskName: string, value: number): void {
        this.taskEnabledMap.set(taskName, value);
        setToStorage(`${this.survicateWindowString}_${this.sessionStorageTasksKey}`, Array.from(this.taskEnabledMap.entries()));
    }

    public clearSurvicateSessionStorage(): void {
        sessionStorage.removeItem(`${this.survicateWindowString}_${this.sessionStorageTasksKey}`);
    }

    public static getInstance(): SurvicateService {
        if (!SurvicateService.instance) {
            SurvicateService.instance = new SurvicateService(survicateConfig);
        }
        return SurvicateService.instance;
    }

}